(function ($, njm) {
    'use strict';

    njm.views.njmsharesHero = Backbone.View.extend({

        events: {
            'click #scroll_button': 'onScrollButtonClick'
        },

        onScrollButtonClick: function () {
            $('html, body').animate({
                scrollTop: $('.comp-njmshares-videos').offset().top - 140
            }, 500);
        }
    });
})(jQuery, njm);
